export const LOADER_STATUS         =       'LOADER_STATUS';
export const GET_STATUS            =       'GET_STATUS';
export const STATUS_FALLA          =       'STATUS_FALLA';
export const SAVE_LOADER_STATUS    =       'SAVE_LOADER_STATUS';
export const FORM_STATUS_FAIL      =       'FORM_STATUS_FAIL';

